var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6 col-sm-12",staticStyle:{"margin":"0 auto"}},[_c('h1',[_vm._v("Projets")]),_c('br'),_c('hr'),_c('br'),_c('ProjetsComponent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }